import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, CircularProgress, Typography, Alert } from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleGoogleCallback, isAuthenticated, loading } = useAuth();
  const [error, setError] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    const error = searchParams.get("error");

    if (error) {
      setError("Authentication failed. Please try again.");
      setTimeout(() => {
        navigate("/");
      }, 3000);
      return;
    }

    if (token) {
      try {
        handleGoogleCallback(token);
        // Don't navigate yet - let the useEffect below handle it
      } catch (err) {
        console.error("Error processing authentication:", err);
        setError("Failed to complete authentication. Please try again.");
        setTimeout(() => {
          navigate("/");
        }, 3000);
      }
    } else {
      setError("No authentication token received.");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    }
  }, [searchParams, navigate, handleGoogleCallback]);

  // Navigate to /app once authentication is complete
  useEffect(() => {
    if (isAuthenticated && !loading) {
      navigate("/app");
    }
  }, [isAuthenticated, loading, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        gap: 3,
      }}
    >
      {error ? (
        <>
          <Alert severity="error" sx={{ maxWidth: 400 }}>
            {error}
          </Alert>
          <Typography variant="body2" color="text.secondary">
            Redirecting to home page...
          </Typography>
        </>
      ) : (
        <>
          <CircularProgress size={60} />
          <Typography variant="h6" color="text.secondary">
            Completing authentication...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default AuthCallback;
